import React, { Component } from 'react';
import { Button, Spin, Checkbox, message } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import Container from '../../../../../components/Container';
import { GetQueryString } from '../../utils/utils';
import styles from './index.less';

@connect(({ moduleCreate }) => ({
  ...moduleCreate,
}))
class Associated extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      allChecked: false,
    };
    this.id = GetQueryString('id');
  }

  componentDidMount() {
    this.fetchTemplateReleaseList();
  }

  fetchTemplateReleaseList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'moduleAssociated/fetchTemplateReleaseList',
      params: { templateId: this.id },
    })
      .then(res => {
        if (res && res[0] && res[0] === 'All') {
          this.setState({ allChecked: true });
        }
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleOk = () => {
    const { dispatch } = this.props;
    const { allChecked } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'moduleAssociated/fetchTemplateRelease',
      params: {
        templateId: this.id,
        orgList: allChecked ? [{ orgId: 'All', orgName: '' }] : [],
      },
    })
      .then(() => {
        router.goBack();
        message.success('关联成功');
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  onChange = e => {
    this.setState({ allChecked: e.target.checked });
  };

  renderFooter = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <Button type="primary" onClick={this.handleOk}>
          确定
        </Button>
      ),
    };

    return footerParams;
  };

  render() {
    const { loading, allChecked } = this.state;
    return (
      <Container breStates={!0} version={2} footerParams={this.renderFooter()}>
        <Spin spinning={loading}>
          <div className={styles['module-associated']}>
            <div className="title">请选择需要关联的学校</div>
            <div>
              <Checkbox checked={allChecked} onChange={this.onChange}>
                全部学校
              </Checkbox>
            </div>
          </div>
        </Spin>
      </Container>
    );
  }
}

export default Associated;
